exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "mat-sidenav img {\n  max-width: 180px; }\n\nmat-toolbar md-icon {\n  padding: 0 14px; }\n\nmain {\n  min-height: 90vh; }\n\nmat-progress-bar {\n  position: absolute;\n  top: 0;\n  z-index: 100; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/AppModule/AppComponent/app.component.scss
// module id = ../../../../../src/AppModule/AppComponent/app.component.scss
// module chunks = main